import { GzDashboardFiltersBarWebComponent } from './component/GzDashboardFiltersBarWebComponent';

export { GzDashboardFiltersBarWebComponent };
